<video id="local-screen-video-tag" [class.fullsize]="fullsized" playsinline autoplay muted></video>
